export const isEmpty = (str) => !str.trim().length;
